<template>
  <div>
    <div class="asset-panel">
      <h4>이용약관</h4>

      
    <vs-select
      label="개정일"
      v-model="selectedIndex"
      >
      
      <vs-select-item :key="ver.id" :value="index" :text="ver.title" v-for="(ver,index) in histories" />
    </vs-select>
    <div class="policy-box" v-html="term.contents"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selectedIndex: 0,
        histories: []
      };
    },
    computed: {
      term() {
        return this.histories[this.selectedIndex] || {};
      }
    },
    created() {
      this.$api.Setting.getTermsList()
    .then(({body}) => {
      this.histories = body;
    });
    }
  }
</script>

<style scoped>

</style>